import MasonryView from './MasonryView.vue';
import ViewHeader from '@/views/ViewHeader.vue';

export default function ({ path, viewConfig, configIdentifier }) {
  let routes = [
    {
      path: `/${path}`,
      name: path,
      title: viewConfig.title,
      components: { default: MasonryView, header: ViewHeader },
      // meta: { type: 'View', viewConfig, baseRoute: true, configIdentifier, hideToolbar: viewConfig.hideToolbarExtension },
      meta: {
        type: 'View',
        viewConfig,
        baseRoute: true,
        configIdentifier,
        isRouterViewFixed: true,
      },
    },
  ];

  return routes;
}
